import PropTypes from 'prop-types';
import moment from 'moment';
// material
import { TableRow, TableCell } from '@mui/material';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import DeleteIcon from '@mui/icons-material/Delete';
// component
import Controls from '../../controls/Controls';
import { DecryptData } from '../../../utils/encryptDecrypt';

export default function UserTypeRow({ usertype, openInPopup, deleteUserType, index }) {
    const currentUserRole = DecryptData(localStorage.getItem('role'))
    const displayDatasets = (obj) => {
        let displayList = obj?.map((item) => item['dataSetName'])
        return displayList?.length ? displayList.join(', ')  : ""
    }

    const displayDashboard = (obj) => {
        let displayList = obj?.map((item) => item['dashboardName'])
        return displayList?.length ? displayList.join(', ')  : ""
    }

    return (
        <TableRow key={usertype?._id}>
            <TableCell>{index}</TableCell>
            <TableCell>{usertype?.userTypeName}</TableCell>
            <TableCell>{displayDatasets(usertype?.datasetAccess)}</TableCell>
            <TableCell>{displayDashboard(usertype?.dashboardAccess)}</TableCell>
            <TableCell> {moment(usertype?.updatedAt).fromNow()} </TableCell>
            <TableCell>
                <Controls.ActionButton
                    color="root"
                    onClick={() => { openInPopup(usertype) }}
                >
                    <EditOutlinedIcon fontSize="small" />
                </Controls.ActionButton>
                {
                    currentUserRole == 'superadmin' && <Controls.ActionButton
                        color="root"
                        onClick={() => {
                            deleteUserType(usertype)
                        }}
                    >
                        <DeleteIcon />
                    </Controls.ActionButton>
                }               
            </TableCell>
        </TableRow>
    )
}
UserTypeRow.propTypes = {
    usertype: PropTypes.object
}